document.addEventListener("DOMContentLoaded", () => {
    const discountAmount = document.querySelector(".variableBundleDiscount")
        ? Number(document.querySelector(".variableBundleDiscount").value)
        : null;
    const overDiscountAmount = document.querySelector(
        ".variableBundleOverDiscount"
    )
        ? Number(document.querySelector(".variableBundleOverDiscount").value)
        : null;
    const handleOpenModal = () => {
        const modalContainer = document.querySelector(
            ".variable-bundle-container"
        );
        if (
            modalContainer.classList.contains(
                "variable-bundle-container-hidden"
            )
        ) {
            openModal();
        }
    };
    const handleMouseUp = (e) => {
        const container = document.querySelector(".variable-bundle-modal");
        if (
            container !== e.target &&
            !container.contains(e.target) &&
            !document
                .querySelector(".variable-bundle-container")
                .classList.contains("variable-bundle-container-hidden")
        ) {
            closeModal();
        }
    };
    const handleQuantityBtnClick = (e, inputTarget) => {
        const el = e.currentTarget;
        const targetValue = Number(inputTarget.value);
        if (el.name === "minus") {
            if (targetValue > 0) {
                inputTarget.value = targetValue - 1;
            }
        } else {
            inputTarget.value = targetValue + 1;
        }
        inputQuantityChange(inputTarget);
    };
    const handleQuantityChange = (e) => {
        const el = e.target;
        inputQuantityChange(el);
    };
    const handleSubmitProduct = async (e) => {
        const btn = e.currentTarget;
        btn.classList.add("loading");
        btn.classList.add("pointer-event-disabled");
        const JSONData = [
            ...document.querySelectorAll(
                ".variable-bundle-modal-product-quantity-input"
            ),
        ]
            .filter((item) => item.value > 0)
            .flatMap((value) => {
                const jsonVariant = JSON.parse(value.dataset.variant);
                jsonVariant["quantity"] = Number(value.value);
                return jsonVariant;
            });
        const formData = { items: [] };
        const bundleId = document.querySelector(".variableBundleProduct").value;
        const quantity = Number(
            document.querySelector(".quantity__input-bundles")?.value ?? 1
        );
        let bundlePrice = Number(
            document.querySelector(".bundle-product-price").value / 100
        );
        const preselectedProduct =
            document.querySelector(".preselectedProduct")?.value ?? null;
        const bundleImage = document.querySelector(".bundleImage").value;
        let originalPrice = 0;
        const choices = {};
        const rawQuantitiesArray = [];
        const quantitiesArray = [];
        const childIds = [];
        const auxChildIds = [];
        const childImages = [];
        const jsonValuesSorted = sortJSON(JSONData, "childProductTitle", "asc");
        const rawPricesArray = [];
        jsonValuesSorted.map((inputValue) => {
            childIds.push(inputValue.childProductId);
            auxChildIds.push(inputValue.childProductId);
            auxChildIds.push(inputValue.quantity);
            originalPrice += Number(
                (inputValue.childProductPrice / 100) *
                    inputValue.quantity *
                    quantity
            );
            rawQuantitiesArray.push(inputValue.quantity * quantity);
            childImages.push(inputValue.featured_image);
            rawPricesArray.push(
                Number(
                    (inputValue.childProductPrice / 100) *
                        inputValue.quantity *
                        quantity
                )
            );
        });
        childIds.push(bundleId);
        auxChildIds.push(bundleId);
        const individualKey = generate_hash(auxChildIds);
        let finalPricesArray = calculate_discounted_prices_fixed(
            rawPricesArray,
            bundlePrice
        );
        if (discountAmount) {
            finalPricesArray = calculate_discounted_prices_percent(
                rawPricesArray,
                discountAmount
            );
            bundlePrice = finalPricesArray.reduce(
                (partialSum, a) => partialSum + a,
                0
            );
        }
        if (overDiscountAmount) {
            finalPricesArray = calculate_discounted_prices_percent(
                finalPricesArray,
                overDiscountAmount
            );
            bundlePrice = finalPricesArray.reduce(
                (partialSum, a) => partialSum + a,
                0
            );
        }
        finalPricesArray = adjust_discounted_prices(
            finalPricesArray,
            rawQuantitiesArray
        );
        const rawItem = {
            id: bundleId,
            quantity: quantity,
            properties: {
                _bundleproduct: "true",
            },
        };
        jsonValuesSorted.map((inputValue, inputValueIndex) => {
            quantitiesArray.push({
                id: inputValue.childProductId,
                quantity: inputValue.quantity,
                handle: inputValue.handle,
                price: discountAmount
                    ? {
                          amount: Number(inputValue.childProductPrice / 100),
                          currencyCode: Shopify.currency.active,
                      }
                    : undefined,
            });
        });
        if (preselectedProduct) {
            quantitiesArray.push({
                id: preselectedProduct,
                quantity: 1,
                price: discountAmount
                    ? {
                          amount: 0,
                          currencyCode: Shopify.currency.active,
                      }
                    : undefined,
                isPreselectedProduct: true,
            });
        }
        choices["_quantitiesarray"] = JSON.stringify(quantitiesArray);
        choices["_bundleimage"] = bundleImage;
        rawItem.properties = choices;
        formData.items.push(rawItem);
        const response = await fetch(
            window.Shopify.routes.root + "cart/add.js",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(formData),
            }
        )
            .then((response) => {
                return response.json();
            })
            .catch((error) => {
                console.error("Error:", error);
            });
        if (response) {
            updateCartDrawer();
            resetInputs();
            closeModal();
            btn.classList.remove("loading");
            btn.classList.remove("pointer-event-disabled");
        }
    };
    function inputQuantityChange(el) {
        const productContainer = el.parentNode.parentNode.parentNode;
        const icon = productContainer.querySelector(
            ".variable-bundle-modal-product-check"
        );
        if (/\d/.test(el.value)) {
            const quantity = Number(el.value);
            if (quantity > 0) {
                icon.style.opacity = 1;
            } else {
                icon.style.opacity = 0;
                el.value = 0;
            }
        } else {
            icon.style.opacity = 0;
            el.value = 0;
        }
        checkMaxVariableAmount();
    }
    function resetInputs() {
        document
            .querySelectorAll(".variable-bundle-modal-product-quantity-input")
            .forEach((el) => {
                el.value = 0;
            });
        document
            .querySelectorAll(".variable-bundle-modal-product-check")
            .forEach((item) => {
                item.style.opacity = 0;
            });
        checkMaxVariableAmount();
    }
    document
        .querySelectorAll(".variable-bundle-modal-header-btn")
        .forEach((item) => {
            item.addEventListener("click", handleSubmitProduct);
        });
    document
        .querySelectorAll(".variable-bundle-btn-add-to-cart")
        .forEach((item) => {
            item.addEventListener("click", handleOpenModal);
        });
    document
        .querySelectorAll("#variable-bundle-modal-header-btn-close")
        .forEach((item) => {
            item.addEventListener("click", closeModal);
        });
    document
        .querySelectorAll(".variable-bundle-modal-product-quantity .quantity")
        .forEach((container) => {
            const inputTarget = container.querySelector(
                ".variable-bundle-modal-product-quantity-input"
            );
            container
                .querySelectorAll(".variable-bundle-modal-product-quantity-btn")
                .forEach((btn) => {
                    btn.addEventListener("click", (e) => {
                        handleQuantityBtnClick(e, inputTarget);
                    });
                });
            inputTarget.addEventListener("change", handleQuantityChange);
        });
    document
        .querySelectorAll(".variable-bundle-modal-header-selector-underline")
        .forEach((item) => {
            item.addEventListener("click", resetInputs);
        });
    document.querySelectorAll(".quantity__input-bundles").forEach((item) => {
        item.addEventListener("change", () => checkMaxVariableAmount());
    });
    document.body.addEventListener("mouseup", handleMouseUp);
});

const openModal = () => {
    const modalContainer = document.querySelector(".variable-bundle-container");
    modalContainer.classList.remove("variable-bundle-container-hidden");
    document.body.classList.add("hidden-scroll");
};

const closeModal = () => {
    const modalContainer = document.querySelector(".variable-bundle-container");
    modalContainer.classList.add("variable-bundle-container-hidden");
    document.body.classList.remove("hidden-scroll");
};

function checkMaxVariableAmount() {
    const variableBundleQuantity = Number(
        document.querySelector(".variableBundleQuantity")?.value ?? 1
    );
    const discountAmount = document.querySelector(".variableBundleDiscount")
        ? Number(document.querySelector(".variableBundleDiscount").value)
        : null;

    const overDiscountAmount = document.querySelector(
        ".variableBundleOverDiscount"
    )
        ? Number(document.querySelector(".variableBundleOverDiscount").value)
        : null;
    const totalPriceContainer = document.querySelector(
        ".variable-bundle-total-price"
    );
    const finalPriceContainer = document.querySelector(
        ".variable-bundle-final-price"
    );
    const savedPriceContainer = document.querySelector(
        ".variable-bundle-saved-price"
    );
    let quantitySum = 0;
    const quantity = Number(
        document.querySelector(".quantity__input-bundles")?.value ?? 1
    );
    const jsonData = [
        ...document.querySelectorAll(
            ".variable-bundle-modal-product-quantity-input"
        ),
    ]
        .filter((el) => el.value > 0)
        .flatMap((el) => {
            quantitySum += Number(el.value);
            const jsonVariant = JSON.parse($(el).attr("data-variant"));
            jsonVariant["quantity"] = Number(el.value) * quantity;
            return jsonVariant;
        });
    if (quantitySum <= variableBundleQuantity) {
        //Calculate and show RawPrices
        const rawPrices = jsonData.map((item) => {
            return Number((item.childProductPrice / 100).toFixed(2));
        });
        const rawPrice = rawPrices.reduce(
            (partialSum, a, index) => partialSum + a * jsonData[index].quantity,
            0
        );
        if (quantitySum == variableBundleQuantity) {
            let finalPrice = 0;
            if (discountAmount != null && discountAmount > 0) {
                const finalPricesArray = rawPrices.map((value, index) => {
                    return parseFloat(
                        cutOffDecimal(value * (1 - discountAmount / 100), 2) *
                            jsonData[index].quantity *
                            (overDiscountAmount
                                ? cutOffDecimal(1 - overDiscountAmount / 100, 2)
                                : 1)
                    );
                });
                finalPrice = finalPricesArray.reduce(
                    (partialSum, a) => partialSum + a,
                    0
                );
            } else {
                finalPrice = Number(
                    document.querySelector(".bundle-product-price").value / 100
                );
            }
            if (rawPrice != finalPrice) {
                totalPriceContainer.style.display = "block";
                totalPriceContainer.innerText = formatCurrency(rawPrice);
            }
        } else {
            totalPriceContainer.style.display = "none";
            totalPriceContainer.innerText = formatCurrency(0);
        }
        //Calculate and show FinalPrices or bundle price
        if (discountAmount !== null && discountAmount > 0) {
            const finalPricesArray = rawPrices.map((value, index) => {
                return parseFloat(
                    (value * (1 - discountAmount / 100)).toFixed(2) *
                        jsonData[index].quantity *
                        (overDiscountAmount
                            ? cutOffDecimal(1 - overDiscountAmount / 100, 2)
                            : 1)
                );
            });
            const finalPrice = finalPricesArray.reduce(
                (partialSum, a) => partialSum + a,
                0
            );
            finalPriceContainer.innerText = formatCurrency(finalPrice);
            if (quantitySum == variableBundleQuantity) {
                const savedPrice = rawPrice - finalPrice;
                if (savedPrice != 0) {
                    savedPriceContainer.style.display = "block";
                    savedPriceContainer.innerText =
                        "You Saved " + formatCurrency(rawPrice - finalPrice);
                }
            } else {
                savedPriceContainer.style.display = "none";
                savedPriceContainer.innerText =
                    "You Saved " + formatCurrency(0);
            }
        } else {
            finalPriceContainer.innerText = formatCurrency(
                Number(
                    (document.querySelector(".bundle-product-price").value /
                        100) *
                        (overDiscountAmount
                            ? cutOffDecimal(1 - overDiscountAmount / 100, 2)
                            : 1)
                )
            );
        }
    }
    if (quantitySum == 0 || quantitySum > variableBundleQuantity) {
        totalPriceContainer.style.display = "none";
        totalPriceContainer.innerText = formatCurrency(0);
        finalPriceContainer.innerText = formatCurrency(0);
        savedPriceContainer.style.display = "none";
        savedPriceContainer.innerText = "You Saved " + formatCurrency(0);
    }
    const progressBar = document.querySelector(
        ".variable-bundle-modal-header-progress-bar-container-bar"
    );
    progressBar.style.width =
        (quantitySum <= variableBundleQuantity
            ? (quantitySum / variableBundleQuantity) * 100
            : 100) + "%";
    progressBar.style.background =
        quantitySum <= variableBundleQuantity
            ? progressBar.getAttribute("data-background-color")
            : progressBar.getAttribute("data-background-error-color");
    const infoSelection = document.querySelector(
        ".variable-bundle-modal-header-selector-info-selected"
    );
    infoSelection.innerText =
        quantitySum > 0 && quantitySum <= variableBundleQuantity
            ? quantitySum + " out of " + variableBundleQuantity + " Selected"
            : quantitySum == 0
            ? "None Selected"
            : "Select up to " + variableBundleQuantity + " products";
    if (quantitySum === variableBundleQuantity) {
        document
            .querySelectorAll(".variable-bundle-modal-product")
            .forEach((container) => {
                if (
                    container.querySelector(
                        ".variable-bundle-modal-product-quantity-input"
                    ).value == 0
                ) {
                    container.classList.add(
                        "variable-bundle-modal-product-disabled"
                    );
                }
                container.querySelector(
                    "[name=plus].variable-bundle-modal-product-quantity-btn"
                ).disabled = true;
            });
        document
            .querySelectorAll(".variable-bundle-modal-header-btn")
            .forEach((item) => {
                item.disabled = false;
            });
    } else {
        document
            .querySelectorAll(".variable-bundle-modal-product")
            .forEach((container) => {
                if (
                    container.classList.contains(
                        "variable-bundle-modal-product-disabled"
                    )
                ) {
                    container.classList.remove(
                        "variable-bundle-modal-product-disabled"
                    );
                }
                document
                    .querySelectorAll(
                        "[name=plus].variable-bundle-modal-product-quantity-btn"
                    )
                    .forEach((item) => {
                        item.disabled = false;
                    });
            });
        document
            .querySelectorAll(".variable-bundle-modal-header-btn")
            .forEach((item) => {
                item.disabled = true;
            });
    }
}

function calculate_discounted_prices_fixed(child_prices, bundle_price) {
    child_prices = child_prices.map((price) => makeDecimal(price));
    bundle_price = makeDecimal(bundle_price);

    const total_child_price = child_prices.reduce(
        (acc, price) => acc.plus(price),
        new Decimal(0)
    );

    const discount_factor = new Decimal(bundle_price).div(total_child_price);

    const discounted_prices = [];
    for (let i = 0; i < child_prices.length - 1; i++) {
        discounted_prices.push(
            new Decimal(child_prices[i]).times(discount_factor).toFixed(2) * 1
        );
    }

    discounted_prices.push(
        new Decimal(bundle_price)
            .minus(
                discounted_prices.reduce(
                    (acc, price) => acc.plus(price),
                    new Decimal(0)
                )
            )
            .toFixed(2) * 1
    );
    return discounted_prices;
}

function calculate_discounted_prices_percent(child_prices, discount_value) {
    child_prices = child_prices.map((price) => makeDecimal(price));
    discount_value = makeDecimal(discount_value);

    const discount_factor = new Decimal(100 - discount_value).div(100);

    const total_child_price =
        child_prices.reduce((acc, price) => acc.plus(price), new Decimal(0)) *
        discount_factor;

    const discounted_prices = [];
    for (let i = 0; i < child_prices.length - 1; i++) {
        discounted_prices.push(
            new Decimal(child_prices[i]).times(discount_factor).toFixed(2) * 1
        );
    }

    discounted_prices.push(
        new Decimal(total_child_price)
            .minus(
                discounted_prices.reduce(
                    (acc, price) => acc.plus(price),
                    new Decimal(0)
                )
            )
            .toFixed(2) * 1
    );
    return discounted_prices;
}

function adjust_discounted_prices(price_array, quantities_array) {
    let axu_array = [];
    for (let i = 0; i < price_array.length; i++) {
        let price = price_array[i];
        let quantity = quantities_array[i];
        axu_array.push(new Decimal(price).div(quantity).toFixed(2) * 1);
    }
    return axu_array;
}

function cutOffDecimal(number, decimalPlaces) {
    let factor = Math.pow(10, decimalPlaces);
    return Math.floor(number * factor) / factor;
}
